


























































































































































































































import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import NiceSelect from "./NiceSelect.vue";
import {Mixin} from "@/mixins";
import store from '@/store';

@Component({
    components: {
        NiceSelect
    },
    name: "Address",
})
export default class Address extends Mixins(Mixin) {
    @Prop({default: () => []})
    except!: Array<string>;

    @Prop({default: () => []})
    private readonly readonlyInputs!: Array<string>;

    store = store();

    get countriesForSelect() {
        let ret: { [key: number]: string } = {};
        if (this.store.availableCountries === null || Object.keys(this.store.availableCountries!).length === 0) {
            return null;
        }

        for (let [key, country] of Object.entries(this.store.availableCountries)) {
            ret[parseInt(key)] = country.name;
        }
        return ret;
    }

    get addressType() {
        return this.$vnode.key as 'billingAddress' | 'deliveryAddress';
    }
}

